import { schema } from 'normalizr';
import labelSchema from './label';
import pageCategorySchema from './pageCategory';
import collectionSchema from './collection';

const pageSchema = new schema.Entity('pages', {
  targets: [labelSchema],
  categories: [pageCategorySchema],
  collections: [collectionSchema],
});

export default pageSchema;
